module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/35lWb3/tc-custom/9781423623168.jpg?1720805320812",
      "alt": "This image is the cover for the book Mastering the Art of Southern Cooking"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Mastering the Art of Southern Cooking\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("This definitive guide to Southern cooking methods and techniques by the creators of the PBS show "), _c('i', [_vm._v("New Southern Cooking")]), _vm._v(" features more than 600 recipes"), _c('i', [_vm._v(".")])]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" In "), _c('i', [_vm._v("Mastering the Art of Southern Cooking")]), _vm._v(", Nathalie Dupree and Cynthia Graubart present the most comprehensive book on Southern cuisine in nearly a century. Based on years of research, Dupree and Graubart embrace the great Southern cookbooks and recipes of the past, enhancing them with the foods and conveniences of today."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" With more than 600 recipes and hundreds of step-by-step photographs, Dupree and Graubart make it easy to learn the techniques for creating the South’s fabulous cuisine. From basics such as cleaning vegetables and scrubbing a country ham, to show-off skills like making a soufflé and turning out the perfect biscuit—all are explained and pictured with clarity and plenty of stories that entertain.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Nathalie Dupree, Cynthia Graubart, Pat Conroy\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Gibbs Smith\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0